// src/components/Blogs/Blogs.js

import React, { useEffect, useState } from 'react';
import axios from '../api/axios'; // Assuming axios setup is in '../api/axios'
import './Blogs.css';

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  // NOTE: Assuming the backend runs on 5000 as per previous context
  const API_URL = "https://blog.dietchapter.hosting.acm.org/"; 
  const PUBLIC_DOMAIN = "https://blog.dietchapter.hosting.acm.org/"; 

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/blogs`);
      setBlogs(res.data);
    } catch (err) {
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  const filteredBlogs = blogs.filter(blog =>
    blog.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
      return <div className="blogs-section loading-page">Loading blogs...</div>;
  }
  
  return (
    <section id="blogs-page" className="blogs-section">
      <div className="blogs-header">
        <h2 className="section-title">OUR BLOGS</h2>
        <p className="section-subtitle">
          Stay updated with the latest trends, technologies, and innovations from our ACM Student Chapter
        </p>
        
        {/* Search Bar */}
        <div className="search-filter-row">
          <input
            type="text"
            className="search-input"
            placeholder="Search blogs..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      
      <div className="blog-grid">
        {filteredBlogs.length > 0 ? (
          filteredBlogs.map((blog) => (
            <div key={blog.id} className="blog-card">
              <a
                href={`${PUBLIC_DOMAIN}/${blog.pdfPath.replace(/\\/g, "/")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="blog-link"
              >
                <img
                  src={`${PUBLIC_DOMAIN}/${blog.imagePath.replace(/\\/g, "/")}`}
                  alt={blog.title}
                  className="blog-image"
                />
                <div className="blog-content">
                  <div className="blog-meta">
                    <span className={`blog-category ${blog.category.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}>{blog.category}</span>
                    <span className="blog-date">{blog.date}</span>
                  </div>
                  <h3 className="blog-title">{blog.title}</h3>
                  <p className="blog-abstract">{blog.abstract}</p>
                </div>
              </a>
            </div>
          ))
        ) : (
          <p className="no-results">No blogs found matching "{searchTerm}".</p>
        )}
      </div>
      
      {/* Load More Button */}
      {blogs.length > 8 && <button className="load-more-btn">+ Load More Articles</button>}
    </section>
  );
};

export default Blogs;